export default __webpack_public_path__ + "locales/ru/ChangePasswordDialog.json?hash=b8c8710d1c0fe6e8e883b731c1aa526f";